import React from 'react';
import { Clock, FileText, Award, Truck } from 'lucide-react';
import { features } from '../data/mock';

const iconMap = {
  Clock,
  FileText,
  Award,
  Truck
};

const Features = () => {
  return (
    <section className="py-16 bg-white relative -mt-1">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => {
            const Icon = iconMap[feature.icon];
            return (
              <div
                key={feature.id}
                className="group relative bg-gradient-to-br from-slate-50 to-sky-50 rounded-2xl p-6 hover:shadow-xl transition-all duration-500 border border-slate-100 hover:border-sky-200 overflow-hidden"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                {/* Decorative corner */}
                <div className="absolute top-0 right-0 w-20 h-20 bg-gradient-to-br from-sky-400/10 to-teal-400/10 rounded-bl-full transform translate-x-6 -translate-y-6 group-hover:scale-150 transition-transform duration-500" />
                
                <div className="relative">
                  <div className="w-14 h-14 bg-gradient-to-br from-sky-500 to-teal-500 rounded-xl flex items-center justify-center mb-4 shadow-lg group-hover:scale-110 transition-transform duration-300">
                    <Icon className="text-white" size={26} />
                  </div>
                  <h3 className="text-lg font-bold text-gray-800 mb-2">{feature.title}</h3>
                  <p className="text-sm text-gray-600 leading-relaxed">{feature.description}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Features;